"use strict";

module.exports = /* @ngInject */ function(
  RediWindowInstanceInitializer,
  menuItemRepository,
  RediWindow
) {
  var that = this;

  that.createFromMenuItem = function(menuItem) {
    return new RediWindow(menuItem);
  };

  that.createFromEikonWindowInstance = function(windowInstance) {
    return menuItemRepository
      .getByEikonAppId(windowInstance.appId)
      .then(function(menuItem) {
        var rediWindow = new RediWindow(menuItem);
        rediWindow.setName(windowInstance.instanceId);
        return RediWindowInstanceInitializer.setWindowInstanceAndInitialize(
          rediWindow,
          windowInstance
        );
      });
  };
};



// WEBPACK FOOTER //
// ./app/infrastructure/factories/RediWindowFactory.js